<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4 text-center" is-centered>
        <h1 class="text-text-neutral-primary font-medium">
          {{ t('ancillaries.medicalInsurance.insuranceSum.title') }}
        </h1>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="space-y-4 px-4 pb-4">
        <p class="text-text-neutral-primary whitespace-pre-wrap text-sm">
          {{ t('ancillaries.medicalInsurance.insuranceSum.description') }}
        </p>
        <button
          type="button"
          class="flex w-full items-center justify-between"
          @click="
            openInsuranceDocument(
              appConfig.isDevRuntimeEnv,
              medicalInsuranceConfig.RULES_FILE_LINK,
            )
          "
        >
          <span class="text-text-neutral-primary text-sm font-medium">
            {{ t('ancillaries.medicalInsurance.details.fullRules') }}
          </span>
          <ChevronIcon class="text-text-positive-primary h-6 w-6" />
        </button>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeBottomSheet, FreeHeader, FreeCloseButton } from 'freedom-shared';
  import { openInsuranceDocument } from 'shared';

  import { appConfig } from '@/shared/config';

  import ChevronIcon from '@/assets/images/chevron-arrow-24x24.svg?component';

  import { medicalInsuranceConfig } from '../config';

  defineProps<{
    name: string;
  }>();

  const { t } = useI18n();
</script>
